<template>

  <div class="loninContaner" v-if="showVip">
    <div class="overlay_bg"></div>
    <div id="dialog_tel" class="panel_login animated className">
      <div class="panel_info">
        <i class="close_login" @click="closeBox()">×</i>
        <div class="panel_tab1">
          <div class="vip_title"><span></span>会员类型</div>
          <div class="vip_list">
            <div :class='vipId == item.id?"vip_li active":"vip_li"' v-for="(item,index) in vipData" :key="index" @click="selectVip(item)">
              <div class="vip_name">{{item.title}}</div>
              <div class="vip_price">￥{{item.price}}</div>
              <div class="vip_desc">平均每天{{item.avg}}元</div>
            </div>
          </div>
          <div class="vip_title"><span></span>开通时长</div>
          <div class="vip_time"><span>有效期截止：{{endTime}}</span></div>
          <div class="vip_title"><span></span>注意事项</div>
          <div class="vip_notice">
            购买提示：题库属虚拟产品，不支持退款服务，敬请谅解!
          </div>
        </div>
        <div class="btns">
          <el-button v-on:click="Login" type="primary" :loading="loading" class="login-user-tel-btn">立即购买</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="微信支付" :close-on-click-modal="false" :visible.sync="dialogTableVisible" width="15%" :modal="false" top="26vh" @close="closeWxPay">
      <!-- <span class="box_title">请使用微信扫码支付</span>
      <el-image :src="srcQrcode"></el-image> -->
      <div class="box_pay">
        <span class="box_title">请使用微信扫码支付</span>
        <div class="box_qrcode">
          <el-image :src="srcQrcode"></el-image>
        </div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
export default {
  name: "BuyVipBox",
  props: {
    showVip: { default: true },
    vipData: [],
  }, //
  data() {
    return {
      dialogTableVisible: false,
      loading: false,
      vipId: 0,
      orderNo: "",
      endTime: "",
      srcQrcode: "",
    };
  },

  methods: {
    closeBox() {
      this.$emit("closeLogin", "子向父组件传值");
      this.loading = false;
      this.vipId = 0;
    },

    closeWxPay() {
      this.dialogTableVisible = false;
      this.loading = false;
      this.vipId = 0;
      this.endTime = "";
    },

    selectVip(e) {
      console.log(e);
      const currentTime = new Date();
      currentTime.setDate(currentTime.getDate() + e.days);
      const year = currentTime.getFullYear();
      const month = currentTime.getMonth() + 1; // 月份从0开始，因此需要加1
      const day = currentTime.getDate();
      this.endTime = year + "-" + month + "-" + day;
      this.vipId = e.id;
    },

    async Login() {
      const that = this;
      that.loading = true;
      if (that.vipId === 0) {
        that.$message({
          type: "error",
          message: `操作提示: ${"请选择需要开通的会员类型"}`,
        });
        that.loading = false;
        return;
      }
      that.axios
        .post("/payment/make_qrcode", {
          vid: that.vipId,
        })
        .then((res) => {
          if (res.code == 200) {
            that.orderNo = res.data.orderNo;
            that.srcQrcode = res.data.srcQrcode;
            that.dialogTableVisible = true;
            setInterval(function () {
              that.isPay();
            }, 3200);
            //that.$message.success(res.msg);
            //this.$router.push("/web/index");
          } else {
            that.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    isPay() {
      const that = this;
      console.log(that.orderNo);
      that.axios
        .post("/payment/get_ispay", {
          order_no: that.orderNo,
        })
        .then((res) => {
          if (res.code == 200) {
            window.location.reload();
          } else {
            that.loading = false;
            //that.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style>
.el-dialog {
  z-index: 2008;
}

.box_pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 230px;
}
.box_title {
  width: 100%;
  line-height: 32px;
  text-align: center;
  height: 32px;
}

.box_qrcode {
  width: 200px;
  height: 200px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.loninContaner {
  position: relative;
  z-index: 999;
}
.loninContaner .overlay_bg {
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.6;
  filter: alpha(opacity=60);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 108;
}
.loninContaner .panel_login {
  width: 720px;
  height: auto;
  background-color: #fff;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3);
  -o-box-shadow: 1px 3px 14px rgba(0, 0, 0, 0.3); /* display: none; */
  border-radius: 2px;
}

.loninContaner .panel_login .panel_info {
  padding-top: 20px;
}

.btns {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  width: 97%;
  padding: 15px 0;
}

.login-user-tel-btn {
  width: 200px;
}

.panel_tab1 {
  display: flex;
  flex-direction: column;
}

.panel_tab1 .vip_title {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-weight: bold;
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.panel_tab1 .vip_title span {
  width: 4px;
  height: 12px;
  background-color: #e13b29;
  border-radius: 100px;
  margin-right: 6px;
}

.panel_tab1 .vip_list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.panel_tab1 .vip_li {
  width: 200px;
  padding: 40px 20px;
  margin: 10px 20px 20px 20px;
  background-color: #f7f7f7;
  border-radius: 5px;
  cursor: pointer;
}

.panel_tab1 .vip_li.active {
  background: #fef5e5;
  border: #fdc35d 1px solid;
}

.panel_tab1 .vip_name {
  font-size: 16px;
  color: #272728;
  margin-bottom: 10px;
  text-align: center;
  height: 26px;
  line-height: 26px;
}

.panel_tab1 .vip_price {
  font-size: 26px;
  color: #b88e51;
  margin-bottom: 20px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
}

.panel_tab1 .vip_desc {
  font-size: 12px;
  color: #cdcdcd;
  text-align: center;
}

.panel_tab1 .vip_time {
  width: 100%;
  line-height: 38px;
  padding: 0 15px;
  margin: 10px 0;
  display: flex;
  align-items: center;
}
.panel_tab1 .vip_time span {
  width: 220px;
  height: 36px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAAAXNSR0IArs4c6QAAAkhJREFUaEPV2EFLG0EUB/D/i63JSVoo9KKIBBQUk1vJqVCwtJccPfoxPAgRAir10GOPHnvwWGgPgt4Epd60PVhFQRBFCIqioOjmlUmISTazm53dmezs3pLMZH7v7dsX8ggJu/jP0kewc0tJcvPewhRAv0D8OTHwZzSQBvGHRMDb0KJEkgDvQCcBLkXbDvdE2wz3RdsK74q2ER4IbRs8MNomuBLaFrgy2gZ4KHTc8NDoOOGR0HHBI6PjgGtB9xquDd1LuFZ0r+Da0b2AG0GbhhtDm4QbRZuCG0ebgGtFv3kHDIwClR3g5qB9/KPzX75W9GAReJ1rYve/AY/Xzde64EbRgnu4Atxf6IUbR4tSOV/XWypd0ak0MFSsH3qx2Z4199DSXR7i86s94PSne2W0SVZXtDhueLr+gInLuQeOv8vxKugoXSUQWhzgBsnwquiw8MBocYAolewMkHnbvN2t+DDoMHAldIPqhb87AQbG2uvXq6bdVa7SDkOh/fBuTFC02PeybyTQfJz/Ln1Cldc6H2+Fd2SZb2xXQYvxeK5EXeGRMu2OS4aX9Wm/fDD/pvx8wReuFd2KET/n/a+A63/+vV0ewBzlSsuecGNoherqXMo3SDtZGitXpHA70bUwatmudUR3VPaieRuTznui8lMHXEv3iFQKXpv5CGmnIEqkseI54/ZmGlvoeyrSRPmyNawavJ7p6g+AMkYSFupL+RJMXyhf+irbTvaheQOEVVQzq5SfvfOKmXh3sYAUx5tp5ge8SJ3ReOkk6M35DxlCRHwipYiiAAAAAElFTkSuQmCC),
    #fef5e5;
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: 23px 23px;
  border-radius: 6px;
  line-height: 36px;
  color: #723611;
  padding-left: 20px;
  margin-left: 8px;
  font-size: 14px;
  font-weight: bold;
}

.panel_tab1 .vip_notice {
  line-height: 36px;
  color: #723611;
  padding-left: 30px;
  font-size: 14px;
}
</style>




